import seedgreenAPIAnonymous from "@/utils/seedgreen-api-anonymous";
import { sendToast } from "@/utils/sendToast";
import { loadingController } from "@ionic/vue";
import { useI18n } from "vue-i18n";

export function useSendPasswordReset() {
	const { t } = useI18n();

	return async (email: string) => {
		const loading = await loadingController.create({
			message: t("common.loading-dot"),
		});
		await loading.present();

		try {
			await seedgreenAPIAnonymous.post(
				"v2/ForgotPassword/SendReset",
				JSON.stringify(email),
			);
			sendToast(
				t("user-management.password-reset-email-sent"),
				3000,
				"success",
			);
			return true;
		} catch {
			sendToast(
				t("user-management.password-reset-email-error"),
				3000,
				"danger",
			);
			return false;
		} finally {
			loading.dismiss();
		}
	};
}
